import './icons/fontAwesome';
import './scss/main.scss';
import './shared';

import {registerAjaxLinkListeners} from '@/naja/ajaxLinks';
import {bindInemComponents} from '@/naja/components';
import {initializeLinksThatRequireConfirmation} from '@/naja/confirmDialog';
import {registerFileUploadCountListeners} from '@/naja/FileUploadCount';
import {openAjaxModals} from '@/naja/modals';
import initializePoller from '@/naja/Poller';
import {ProgressBar} from '@/naja/ProgressBar';
import {SnippetProcessor} from '@/naja/SnippetProcessor';
import Chart from 'chart.js/auto';
import naja from 'naja';

import {AutoScrollExtension} from '@/naja/AutoScrollExtension';
import {AutoSubmitFormElementExtension} from '@/naja/AutoSubmitFormElementExtension';
import LazyLoading from '@/naja/LazyLoading';
import {initializeReCaptcha} from '@/naja/reCaptcha';
import {initializeSentry} from '@/shared/sentry';
import moment from 'moment';
// @ts-ignore
import netteForms from '../../vendor/nette/forms/src/assets/netteForms';

initializeSentry();

// Use czech language for dates
moment.locale('cs');

naja.formsHandler.netteForms = netteForms;
naja.registerExtension(SnippetProcessor, initializeLinksThatRequireConfirmation);
naja.registerExtension(SnippetProcessor, registerAjaxLinkListeners);
naja.registerExtension(SnippetProcessor, registerFileUploadCountListeners);
naja.registerExtension(SnippetProcessor, openAjaxModals);
naja.registerExtension(SnippetProcessor, bindInemComponents);
naja.registerExtension(SnippetProcessor, initializeReCaptcha);
naja.registerExtension(SnippetProcessor, initializePoller);
naja.registerExtension(ProgressBar);
naja.registerExtension(AutoScrollExtension);
naja.registerExtension(LazyLoading);
naja.registerExtension(AutoSubmitFormElementExtension);

document.addEventListener('DOMContentLoaded', () => {
    // Prevents NS_ERROR_ILLEGAL_VALUE on large pages in Firefox
    naja.historyHandler.historyAdapter = {
        replaceState: () => {},
        pushState: () => {},
    };

    naja.initialize({history: false, timeout: 120000});
});

(window as any).Chart = Chart;
